export { default } from './AgeGate'
